/*
 * Copyright (c) 2019  Apricad LLC. All Rights Reserved.
 */

import * as React from "react";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import classNames from "classnames";

// CT Kit
import Parallax from "components/Parallax/Parallax.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import componentsStyle from "assets/jss/views/coursePage/coursePageStyle.jsx";

const styles = createStyles(componentsStyle as any);

interface Props extends WithStyles<typeof styles> {
  staticContext: any;
}

const NotFoundPageBase: React.SFC<Props> = ({
  classes,
  staticContext = {},
}: Props) => {
  // Note:
  // 1. the 'context' has be renamed as staticContext, by StaticRouter
  // 2. If this is rendered on Client, the staticContext won't exist. (Since it comes from StaticRouter, SSR only)
  // See how we sent do res.status(404); in index.js
  staticContext.notFound = true;

  return (
    <Parallax image={require("assets/img/landing.jpg")} filter="dark" banner>
      <div className={classes.container}>
        <GridContainer>
          <GridItem md={8} sm={8} className={classNames(classes.mrAuto)}>
            <div className={classes.brand}>
              <h2>Page Not Found</h2>
            </div>
          </GridItem>
        </GridContainer>
      </div>
    </Parallax>
  );
};

export default {
  component: withStyles(styles)(NotFoundPageBase),
};
